export class ImportBaseState {
    file: File
}